module.exports = __webpack_public_path__ + "static/img/mitaussteller_black.6f628f96.svg";